export default __webpack_public_path__ + "static/media/frequently-asked-questions.52f64da1.svg";